import { render, staticRenderFns } from "./BaseRadioInput.vue?vue&type=template&id=1f125cc1&scoped=true&"
import script from "./BaseRadioInput.vue?vue&type=script&lang=js&"
export * from "./BaseRadioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f125cc1",
  null
  
)

export default component.exports